import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var DeliveryMethodsReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default DeliveryMethodsReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/DeliveryMethods/DeliveryMethodsReduxProps.ts
// module id = 345
// module chunks = 0